import { css } from 'styled-components';

import { getColorByName } from '~/helpers/getColors';

const MetaNavigationChildWrapper = css`
  position: relative;
  z-index: 2;
  background: ${(props) =>
    getColorByName(props.theme, props.theme.header.bgColor)};
  color: ${({ theme }) => theme.color.primary800};
  display: flex;
  align-items: center;
  justify-content: flex-end;
  min-height: ${(props) => props.theme.header.height}px;

  @media (${(props) => props.theme.header.mobileSwitch}) {
    min-height: ${(props) => props.theme.header.heightMobile}px;
  }

  ul {
    min-height: ${(props) => props.theme.header.height}px;
    align-items: center;

    @media (${(props) => props.theme.header.mobileSwitch}) {
      min-height: 0;
    }
  }
`;

export default MetaNavigationChildWrapper;
